itsoftApp.createModule("video",  function () {
    var module = this;
    var ytLoaded = false;

    var videoPlay = function (video) {
        video.play();
    }

    var videoPause = function (video) {
        video.pause();
    }

    var initVideo = function (videoBlock) {
        var videoInline = videoBlock.hasAttribute("data-video-inline");
        var isYoutubeVideo = videoBlock.classList.contains("js-video-yt");

        if (!videoInline && !isYoutubeVideo) {
            itsoftApp.modules.popups.callback.create(videoBlock, videoPlay, videoPause);
        } else if (isYoutubeVideo && !ytLoaded) {
            ytLoaded = true;
            itsoftApp.modules.youtubeVideo.callback();
        }
    }

    module.callback = initVideo;
});